export default "__VITE_ASSET__20044a1b__"